import { Component, Vue, Watch } from 'vue-property-decorator';
import appStore from '@/store/app';
import ordersStore from '@/store/orders';
import { Order, OrderLine } from '@/models';
import CardComponent from '@/components/CardComponent';
import CustomToolbar from '@/components/CustomToolbar';
import { getYear } from 'date-fns';

@Component({
   components: { CardComponent, CustomToolbar },
})
export default class OrdersTransmitted extends Vue {

   private selected: Order | null = null;
   private pageNumber = 1;
   private pageSize = appStore.pageSize;
   private year = ordersStore.ordersYear || getYear(new Date());
   private detailsToShow: string[] = [];

   get loading(): boolean {
      return appStore.isLoading;
   }

   get years(): number[] {
      const firstYear = getYear(new Date());
      return Array.from<number, number>({ length: 16 }, (x, i) => firstYear - i);
   }

   get orders(): Order[] {
      return ordersStore.orders;
   }

   get total(): number {
      return ordersStore.totalOrders;
   }

   private async created() {
      await this.fetchOrdersAsync();
   }

   private async mounted() {
      await appStore.activateMenuById({ rootId: 100, subMenuId: 103 });
   }

   @Watch('year', { immediate: false, deep: false })
   private async onSearchTypeChanged(value: number, previousValue?: number) {

      if (!previousValue) return;
      this.year = value;
      this.pageNumber = 1;
      await this.fetchOrdersAsync();
   }

   private select(row: Order, oldRow: Order | null): void {
      this.selected = row;
   }

   private async onPageChange(page: number) {
      this.pageNumber = page;
      await this.fetchOrdersAsync();
   }

   private getOrderLines(order: Order): OrderLine[] {
      return order ? order.lines || [] : [];
   }

   private async refresh() {
      await this.onPageChange(1);
   }

   private async fetchOrdersAsync() {
      await ordersStore.fetchOrdersAsync({ year: this.year, pageSize: this.pageSize, pageNumber: this.pageNumber });
   }

   // private print() {
   //    if (this.order) {
   //       this.detailsToShow = [];
   //       this.orders.forEach((order) => {
   //          this.detailsToShow.push(order.id);
   //       });
   //    }
   //    this.$nextTick(() => {
   //       window.print();
   //    });
   // }
}
